import React from "react";
import { TableCell } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Modal } from "src/Components";
import { IAdditional } from "src/Tables/TableTemplate/tableTemplate";
import { IAssetClassTableReport } from "src/Interfaces/assetClass";
import EditAssetClassModal from "./EditAssetClassModal";
import EditAssetClassSingleModal from "./EditAssetClassSingleModal";

const EditIconButton: React.FC<{ onClick: () => void; disabled?: boolean }> = ({
  onClick,
  disabled,
}) => (
  <div className="w-min mx-auto">
    <div
      className={
        disabled
          ? "rounded p-1 opacity-40 cursor-not-allowed"
          : "hover:bg-slate-300 transition-all rounded p-1"
      }
      onClick={disabled ? undefined : onClick}
    >
      <EditIcon
        className={disabled ? "text-slate-400" : "text-sky-700 cursor-pointer"}
      />
    </div>
  </div>
);

/**
 * Builds the "دکمه ویرایش" column.
 * - Column header button => group edit of the multi-selected rows. Disabled
 *   until at least one row is selected; pre-selects the selected rows' ISINs.
 * - Each row button => single edit of that row's instrument.
 *
 * @param resolveInstrumentIds maps the table's selected row ids to ISIN list.
 */
export const getAssetClassAdditional =
  (
    resolveInstrumentIds: (selectedRowsIds: number[]) => string[],
  ): IAdditional<IAssetClassTableReport> => {
    const AdditionalHeader: React.FC<{
      onAction: () => void;
      selectedRowsIds: number[];
      setSelectedRowsIds: (selectedRowsIds: number[]) => void;
    }> = ({ onAction, selectedRowsIds, setSelectedRowsIds }) => {
      const [modalOpen, setModalOpen] = React.useState(false);
      const disabled = !selectedRowsIds.length;

      return (
        <TableCell
          className="!cursor-default bg-white"
          onClick={(e) => e.stopPropagation()}
        >
          {modalOpen && (
            <Modal
              onClose={() => setModalOpen(false)}
              UI={
                <EditAssetClassModal
                  initialInstrumentIds={resolveInstrumentIds(selectedRowsIds)}
                  onSuccess={() => {
                    onAction();
                    setSelectedRowsIds([]);
                    setModalOpen(false);
                  }}
                />
              }
              modalBoxClassName="!min-w-min"
            />
          )}
          <EditIconButton
            onClick={() => setModalOpen(true)}
            disabled={disabled}
          />
        </TableCell>
      );
    };

    const AdditionalCol: React.FC<{
      row: IAssetClassTableReport;
      onAction: () => void;
    }> = ({ row, onAction }) => {
      const [modalOpen, setModalOpen] = React.useState(false);

      if (!row.instrumentId) return <TableCell />;

      return (
        <TableCell onClick={(e) => e.stopPropagation()}>
          {modalOpen && (
            <Modal
              onClose={() => setModalOpen(false)}
              UI={
                <EditAssetClassSingleModal
                  row={row}
                  onSuccess={() => {
                    onAction();
                    setModalOpen(false);
                  }}
                />
              }
              modalBoxClassName="!min-w-min"
            />
          )}
          <EditIconButton onClick={() => setModalOpen(true)} />
        </TableCell>
      );
    };

    return {
      getHeader: AdditionalHeader,
      getRow: AdditionalCol,
    };
  };
